angular.module('iconoglobe')
.directive('uploadImage',["$http", function (http) {
  'use strict';
    return {
      scope: true,
      link: function(scope, el, attrs){
        el.change(function(){
          scope.uploadImage(this, attrs.uploadto);
        });
      },
      controller: function ($scope, $http) {
        $scope.uploadImage = function(element, type){
          var file = element.files[0];
          var imagefile = file.type;
          var match = ["image/jpeg", "image/png", "image/jpg"];
          if (!((imagefile == match[0]) || (imagefile == match[1]) || (imagefile == match[2]))) {
            $scope.$apply(function() {
              $scope.message = "Please Select A valid Image File. Only jpeg, jpg and png Images type allowed";
              $scope.message_test = "Please Select A valid Image File. Only jpeg, jpg and png Images type allowed";
              $scope.PopupnotificationModal = true;
            });
          } else {
            var reader = new FileReader();
            // reader.onload = imageIsLoaded;
            reader.readAsDataURL(element.files[0]);
            var fd = new FormData();
            fd.append("file", file);
            if (type == "event") {
              var url = "/establishment/uploadEventPhoto";
              fd.append("event", $scope.eventId);
            } else {
              var url = "/establishment/uploadEstaPhoto";
              fd.append("establish", $scope.estaId);
            }
            console.log($scope.estaPhotos);
            $http.post(url, fd, {
              withCredentials: true,
              headers: {
                'Content-Type': undefined
              },
              transformRequest: angular.identity
            }).then(function() {
              if (type == "event") {
                $http.post("/establishment/getPhotosEvents", {
                  eventId: $scope.eventId
                }).then(function(res) {
                  
                  $scope.$emit('updateEventImages', res.data);
                }, function(err) {});
              } else {
                $http.post("/establishment/getPhotosEstablishment", {
                  estaId: $scope.estaId
                }).then(function(res) {
                  
                  $scope.$emit('updateEstaImages', res.data);
                }, function(err) {});
              }
            }, function(err) {});
          }
        }
      }
    }
}])